import * as React from 'react';
import * as classNames from 'classnames';
import { ChildProps, graphql } from 'react-apollo';
import gql from 'graphql-tag';
import bind from '../bind';
import { withUserContext, IUserContext } from './user_context_provider';
import CmsPageComponent from './cms_page_component';

import { CommonsCmsCmsEmbed } from '../rql';
import trackCmsExperimentComponentFilter from '../track_cms_experiment_component_filter';

/**
 *  off: Don't fetch CMS page+components on the server, initial render is empty
 *  static-only: Fetch CMS page and component configuration server-side, but nothing else.
 *               Renders component placeholders, and any rows that don't rely on additional queries
 *  full: Fetch data server-side for the first two components
 */
type SSRMode = 'off' | 'static-only' | 'full';

interface IOwnProps {
  slug: string;
  ssrMode: SSRMode;
}

type IProps = ChildProps<IUserContext & IOwnProps, CommonsCmsCmsEmbed.Query>;

export class CmsEmbed extends React.Component<IProps, null> {
  get page() {
    return this.props.data?.pages?.[0];
  }

  @bind
  filterComponentsForExperiment(component: CommonsCmsCmsEmbed.Components) {
    return trackCmsExperimentComponentFilter({
      componentData: component,
      user: this.props.user,
    });
  }

  getComponentsForEmbed() {
    if (!this.page.components) { return []; }

    return this.page.components.filter((component) => {
      return component.layoutSection === 'main';
    });
  }

  renderComponents(components: CommonsCmsCmsEmbed.Components[]) {
    return components.filter(this.filterComponentsForExperiment).map((component, index) => {
      return (
        <CmsPageComponent
          key={component.id}
          component={component}
          canSsr={this.props.ssrMode === 'full'}
          layoutSlug={this.page.layoutSlug}
          position={index}
        />
      );
    });
  }

  renderEmbed() {
    const components = this.getComponentsForEmbed();

    return (
      <div className="dynamic-page__one-col">
        {this.renderComponents(components)}
      </div>
    );
  }

  render() {
    const { page } = this;
    if (!page || page.pageNotFound) { return null; }

    const classes = classNames(
      'dynamic-page',
      { 'dynamic-page--flush-with-header': 'none' },
    );

    return (
      <div className={classes}>
        <div>
          {this.renderEmbed()}
        </div>
      </div>
    );
  }
}

const connect = graphql<IProps, CommonsCmsCmsEmbed.Query>(
  gql`
    query Commons_Cms_CmsEmbed(
      $slug: String
      $admin: Boolean
    )
    {
      pages: cmsPagesFetch(input: {
        slugs: [$slug],
        includeDrafts: $admin
      }) {
        _id
        id
        layoutSlug
        components {
          id
          position
          componentType
          data
          layoutSection
          experimentKey
          experimentBucket
        }
        live
        pageNotFound
      }
    }
  `,
  {
    options: (ownProps) => {
      return {
        ssr: ownProps.ssrMode !== 'off',
        variables: {
          slug: ownProps.slug,
          admin: ownProps.user?.isAdmin,
        },
      };
    },
  },
);

export default withUserContext<IOwnProps>(connect(CmsEmbed));



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/src/components/cms_embed.tsx